module.exports = __webpack_public_path__ + "img/6-images_bg.2e5066d7.png";